import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {resultsInfo_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/resultsInfo_template";
import {filterPreset_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterPreset_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterWebsiteUser_template} from "./filterWebsiteUser_template";

declare var ko: any;
declare var page: any;

interface WebsiteUser {
    fullName: string;
    emakiEdit: string;
    email: string;
    registeredBrands: string;
    isEmakiUser: string;
    dateCreated: string;
    titleRegisteredBrands: string;
    mailingLists: string;
    accessPoints: Array<any>;
}

export class websiteUserList_template extends vnTemplate {

    protected filter: filterSimple_template;
    protected pagination: pagination_template;
    protected resultInfos: resultsInfo_template;
    protected brandFilter: multipleSelector_template;
    protected mailingListFilter: multipleSelector_template;
    protected filterPreset: filterPreset_template;
    protected isActiveFilter: multipleSelector_template;
    protected isEmakiUserFilter: multipleSelector_template;
    protected isRegisteredFilter: multipleSelector_template;
    protected isProfileVerifiedFilter: multipleSelector_template;
    protected isPremiumFilter: multipleSelector_template;
    protected accountDetailsTooltip: infoButton_template;
    protected dateFilter: filterDate_template;
    protected userFilter: filterWebsiteUser_template;
    protected displayNameStatusFilter: multipleSelector_template;
    protected displayImageStatusFilter: multipleSelector_template;
    protected coverImageStatusFilter: multipleSelector_template;
    protected hasInteractedFilter: multipleSelector_template;
    protected hasPersonalDataFilter: multipleSelector_template;
    protected masterClassRegistrationFilter: multipleSelector_template;
    protected masterClassRegistrationItems: Array<any> = [];

    protected getTemplateHtml(): string {

        return /* html */ `

            <div class="sub-header filter-preset w-justify">

                    ${this.filterPreset.getHtmlBuild()}
            </div>

            <div class="sub-header">
                <div class="w-justify">
                    <div class="w-left">
                        <div>
                            ${this.brandFilter.getHtmlBuild()}
                        </div>
                        <div>
                            ${this.mailingListFilter.getHtmlBuild()}
                        </div>
                        <div>
                            ${this.isActiveFilter.getHtmlBuild()}
                        </div>
                        <div>
                            ${this.isEmakiUserFilter.getHtmlBuild()}
                        </div>
                        <div>
                            ${this.isRegisteredFilter.getHtmlBuild()}
                        </div>
                        <div>
                            ${this.isProfileVerifiedFilter.getHtmlBuild()}
                        </div>
                        <div>
                            ${this.isPremiumFilter.getHtmlBuild()}
                        </div>
                        <div>
                            ${this.dateFilter.getHtmlBuild()}
                        </div>
                        <!-- ko if: onlyOneBrandSelected -->
                            <div>
                                ${this.displayNameStatusFilter.getHtmlBuild()}
                            </div>
                            <div>
                                ${this.displayImageStatusFilter.getHtmlBuild()}
                            </div>
                            <div>
                                ${this.coverImageStatusFilter.getHtmlBuild()}
                            </div>
                            <div>
                                ${this.hasInteractedFilter.getHtmlBuild()}
                            </div>
                            <div>
                                ${this.hasPersonalDataFilter.getHtmlBuild()}
                            </div>
                        <!-- /ko -->
                        <!-- ko if: brandFilter.selectedItems().length > 0 -->
                            <div>
                                ${this.masterClassRegistrationFilter.getHtmlBuild()}
                            </div>
                        <!-- /ko -->
                        <div>
                            ${this.userFilter.getHtmlBuild()}
                        </div>
                    </div>
                </div>
            </div>

            <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                    <div id="selected-brands"></div>
                    <div id="selected-mailing-lists"></div>
                    <div id="selected-is-active"></div>
                    <div id="selected-is-profile-verified"></div>
                    <div id="selected-is-premium"></div>
                    <div id="selected-is-registered"></div>
                    <div id="selected-display-name-status"></div>
                    <div id="selected-display-image-status"></div>
                    <div id="selected-cover-image-status"></div>
                    <div id="selected-has-interacted"></div>
                    <div id="selected-has-personal-data"></div>
                    <div id="selected-master-class-registrations"></div>
                    <div id="selected-dates"></div>
                    <div id="selected-users"></div>
                </div>
            </div>

            <div class="list-header w-justify" >

                <div class="w-left" data-bind="if: permissions()['newsletter_subscription_import_tool'].read">
                    <button class="btn secondary icon i-add" type="button" data-bind="click: onClickImportWebsiteUsers">Import Newsletter Subscriptions</button>

                     <!-- ko if: onlyOneBrandSelected -->
                    <button class="btn secondary icon i-download" type="button" data-bind="click: onClickExportCsv, disable: isExporting, text: isExporting() ? 'Exporting...' : 'Export to CSV'"></button>
                    <span style="margin-left: 8px;" data-bind="visible: isExporting, text: exportProgressText"></span>
                    <!-- /ko -->
                </div>


                <div class="w-center">

                    <div class="w-filter-keyword" data-bind="template: { name: 'filterSimple-template', data: filter }">
                        <div class="w-search-feild icon i-search2">
                            <input data-bind="textInput: filterKeyword, event: { keyup: onKeyUpFilterAction}, valueUpdate : 'afterkeydown'" type="input" class="search-feild">
                            <input data-bind="value: filterKeywordLastKeyPress" type="hidden">
                            <input date-bind="value: filterKeywordRequestedKeyWord" type="hidden">
                            <button data-bind="event: { click: onClearInput }, css: { 'is-showing' : filterInputClearButton }" class="btn-sec icon i-close" id="close-btn" type="button"></button>
                        </div>
                    </div>
                </div>

                <div class="w-right">
                    <div data-bind="style: { display: paginationIsVisible() ? 'block' : 'none' }">
                        <div id="pagination" class="w-pagination" data-bind="template: { name: 'pagination-template', data: pagination }">
                            <div class="pagination">
                                <input data-bind="value: pageNumber" type="hidden" value="1">
                                <span><a data-bind="event: { click: onClickPageFirst }" class="hidden prev">first</a></span>
                                <ul data-bind="foreach: pages">
                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page active">1</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">2</a></li>

                                    <li><a data-bind="css: { active: isSelected > 0 }, text: pageNumber, event: { click: $parent.onClickPageAction }" class="page">3</a></li>
                                </ul>
                                <span><a data-bind="event: { click: onClickPageLast }" class="hidden next">last</a></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div class="w-list-results" id="list-results">
                <table class="list-results">
                    ${this.resultInfos.getHtmlBuild()}
                    <thead>
                        <tr>
                            <!-- ko if: onlyOneBrandSelected -->
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'fullName') }, css: { 'list-sort-desc': orderByAndDirection()=='fullName_DESC', 'list-sort-asc': orderByAndDirection()=='fullName_ASC' }">Full Name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'displayName') }, css: { 'list-sort-desc': orderByAndDirection()=='displayName_DESC', 'list-sort-asc': orderByAndDirection()=='displayName_ASC' }">Display Name</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'idProfile') }, css: { 'list-sort-desc': orderByAndDirection()=='idProfile_DESC', 'list-sort-asc': orderByAndDirection()=='idProfile_ASC' }">Public ID</span></th>
                                <th><span>Display Name<br/>Status</span></th>
                                <th><span>Custom Display<br/>Image</span></th>
                                <th><span>Custom Display<br/>Image Status</span></th>
                                <th><span>Cover Image</span></th>
                                <th><span>Cover Image<br/>Status</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isProfileVerified') }, css: { 'list-sort-desc': orderByAndDirection()=='isProfileVerified_DESC', 'list-sort-asc': orderByAndDirection()=='isProfileVerified_ASC' }">Profile Verified</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'isPremium') }, css: { 'list-sort-desc': orderByAndDirection()=='isPremium_DESC', 'list-sort-asc': orderByAndDirection()=='isPremium_ASC' }">Premium</span></th>
                                <th><span>Gender</span></th>
                                <th><span>Age Group</span></th>
                                <th><span>Country</span></th>
                                <th><span>Postal/ZIP</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'followerCount') }, css: { 'list-sort-desc': orderByAndDirection()=='followerCount_DESC', 'list-sort-asc': orderByAndDirection()=='followerCount_ASC' }">Followers</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'commentCount') }, css: { 'list-sort-desc': orderByAndDirection()=='commentCount_DESC', 'list-sort-asc': orderByAndDirection()=='commentCount_ASC' }">Posts</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'ratingCount') }, css: { 'list-sort-desc': orderByAndDirection()=='ratingCount_DESC', 'list-sort-asc': orderByAndDirection()=='ratingCount_ASC' }">Ratings</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'reviewCount') }, css: { 'list-sort-desc': orderByAndDirection()=='reviewCount_DESC', 'list-sort-asc': orderByAndDirection()=='reviewCount_ASC' }">Reviews</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'threadCount') }, css: { 'list-sort-desc': orderByAndDirection()=='threadCount_DESC', 'list-sort-asc': orderByAndDirection()=='threadCount_ASC' }">Threads</span></th>
                                <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'itemCount') }, css: { 'list-sort-desc': orderByAndDirection()=='itemCount_DESC', 'list-sort-asc': orderByAndDirection()=='itemCount_ASC' }">Items in Lists</span></th>
                            <!-- /ko -->
                            <th>
                                <div style="display: flex;z-index: 1;position: relative;">
                                    <span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'email') }, css: { 'list-sort-desc': orderByAndDirection()=='email_DESC', 'list-sort-asc': orderByAndDirection()=='email_ASC' }">Email</span>
                                    <div style="transform: translateY(3px);" class="w-tooltips-adv pos-right x-short">${this.accountDetailsTooltip.getHtmlBuild()}</div>
                                </div>
                            </th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'emakiUser') }, css: { 'list-sort-desc': orderByAndDirection()=='emakiUser_DESC', 'list-sort-asc': orderByAndDirection()=='emakiUser_ASC' }">Emaki User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreated') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreated_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreated_ASC' }">Date Created</span></th>
                            <th class="align-right"><span>Delete</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: websiteUsers">
                        <tr  class="cursor">
                            <!-- ko if: $parent.onlyOneBrandSelected -->
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: fullName"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: displayName"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }">
                                    <div class="flex right-click" style="gap: 5px">
                                        <a data-bind="attr: { href: itemLink }">
                                            <span data-bind="text: idProfile"></span>
                                        </a>
                                        <a data-bind="attr: { href: profilePageLink }, css: {'is-hidden': !profilePageLink } ">
                                            <span class="btn icon border only-icon i-link"></span>
                                        </a>
                                    </div>
                                </td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: displayNameStatus"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><img  data-bind="attr: { src: customDisplayImage }" style="max-height: 100px; max-width: 100px;"></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: customDisplayImageStatus"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><img  data-bind="attr: { src: coverImage }" style="max-height: 100px; max-width: 100px;"></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: coverImageStatus"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: isProfileVerified"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: isPremium"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: gender"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: ageGroup"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: country"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: zipCode"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: followerCount"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: commentCount"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: ratingCount"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: reviewCount"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: threadCount"></span></a></td>
                                <td data-bind="event: { click: $parent.onClickEdit }"><a class="right-click" data-bind="attr: { href: itemLink }" ><span data-bind="text: itemCount"></span></a></td>
                            <!-- /ko -->
                            <td data-bind="event: { click: $parent.onClickEdit }"><a style="justify-content: space-between;" class="right-click" data-bind="attr: { href: itemLink }">
                                <span data-bind="text: email"></span>
                                <!-- ko if: $parent.onlyOneBrandSelected -->
                                    <span class="user-icon-wrapper">
                                        <span class="icon i-amazon" data-bind="css: { 'active': isAmazon }"></span>
                                        <span class="icon i-apple" data-bind="css: { 'active': isApple }"></span>
                                        <span class="icon i-discord" data-bind="css: { 'active': isDiscord }"></span>
                                        <span class="icon i-facebook" data-bind="css: { 'active': isFacebook }"></span>
                                        <span class="icon i-google" data-bind="css: { 'active': isGoogle }"></span>
                                        <span class="icon i-openPass" data-bind="css: { 'active': isOpenPass }"></span>
                                        <span class="icon i-twitch" data-bind="css: { 'active': isTwitch }"></span>
                                        <span class="icon i-steam" data-bind="css: { 'active': isSteam }"></span>
                                        <span class="icon i-user-v" data-bind="css: { 'active': isVerified }"></span>
                                    </span>
                                <!-- /ko -->
                            </a></td>
                            <td data-bind="event: { click: $parent.onClickEdit }">
                                <a class="right-click" data-bind="attr: { href: itemLink }">
                                    <span data-bind="text: isEmakiUser, attr: { href: itemLink }"></span>
                                </a>
                            </td>
                            <td data-bind="event: { click: $parent.onClickEdit }">
                                <a class="right-click" data-bind="attr: { href: itemLink }">
                                    <span data-bind="attr: { href: itemLink }, text: new Date(dateCreated.date).toISOString().split('T')[0]"></span>
                                </a>
                            </td>
                            <td class="align-right">
                                <button type="button" data-bind="enable: canDelete, event: { click: $parent.onClickShowDeletePopUp }, clickBubble: false" class="btn border only-icon icon i-delete"></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div id="website-user-delete-dialog" class="w-lightbox light-theme">
                <div id="website-user-delete-dialog-content" style="max-width: 795.98px;" class="lightbox-content website-user-delete">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Delete Website User</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp.bind(this, 'website-user-delete-dialog') }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group user-delete" data-bind="if: websiteUserToDelete() !== null">
                                <p class="data-trash-error ">This action is irreversible. Brand-specific data will be deleted for every selection. If all brands are selected, the user will be deleted entirely.</p><br>
                                <p class="form-text" data-bind="text: 'User: ' + websiteUserToDelete().email"></p>
                                <div id="spec_section_list" class="list-action full-width" data-bind="visible: websiteUserToDelete().accessPointUsers.length > 0">
                                    <div data-bind="foreach: websiteUserToDelete().accessPointUsers">
                                        <div class="user-brand" data-bind="if: accessPoint !== null">
                                            <div>
                                                <input type="checkbox" data-bind="checked: isDelete, attr: {id: 'isDelete_' + $index()}, event: { change: $parent.onChangeSelectBrand }" class="disable: isPremium == true">
                                                <label class="icon i-check" for="isDelete" data-bind="attr: {for: 'isDelete_' + $index()}"></label>
                                            </div>
                                            <div class="brand-icon dark full-icon" data-bind="css: accessPoint.brands[0].iconImage"></div>
                                            <div class="brand-name" data-bind="text: accessPoint.brands[0].name"></div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp.bind(this, 'website-user-delete-dialog') }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDelete }" class="btn highlight">Delete</button>
                        </div>
                    </div>

                </div>
            </div>

            <div id="thread-suggestions-delete-dialog" class="w-lightbox light-theme">
                <div id="thread-suggestions-delete-dialog-content" class="lightbox-content website-user-delete">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Delete Website User</h3>
                            <button type="button"  data-bind="event: { click: onClickHidePopUp.bind(this, 'thread-suggestions-delete-dialog') }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group user-delete" data-bind="if: websiteUserToDelete() !== null">
                                <p class="data-trash-error">The user has the following scheduled or published Thread submissions:</p><br>
                                <div id="spec_section_list" class="list-action full-width">
                                    <div data-bind="foreach: threadSuggestionsToDelete">
                                        <div class="user-brand has-id">
                                            <div class="brand-icon dark full-icon" data-bind="css: $data.iconImage"></div>
                                            <div class="brand-name">Article ID:</div>
                                            <div class="brand-name" data-bind="text: $data.idArticle"></div>
                                        </div>
                                    </div>
                                </div>
                                <p class="data-trash-error" data-bind="text: 'Deleting the website user will set the article status to “Trash”, the publish status to “Unpublished”, and clear the “Prompt Author.'"></p>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickHidePopUp.bind(this, 'thread-suggestions-delete-dialog') }" class="btn">Cancel</button>
                            <button type="button" data-bind="event: { click: onClickDeleteConfirm }" class="btn highlight">Confirm</button>
                        </div>
                    </div>

                </div>
            </div>

            <div id="website-user-export-dialog" class="w-lightbox light-theme" data-bind="css: { 'is-visible': isExportModalVisible }">
                <div id="website-user-export-dialog-content" style="max-width: 480px;" class="lightbox-content website-user-delete">
                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Export to CSV</h3>
                        </div>
                        <div class="form-body">
                            <div class="form-group" style="display: flex; align-items: center; gap: 1rem;">
                                <img src="/assets/images/loading-2.svg" alt="" class="export-loading-spinner" data-bind="visible: isExporting" style="width: 2.2rem; height: 2.2rem; flex-shrink: 0;">
                                <p class="form-text" data-bind="text: exportProgressText" style="margin: 0;"></p>
                            </div>
                        </div>
                        <div class="form-footer">
                            <button type="button" data-bind="event: { click: onClickCancelExport }, disable: isExportCancelling" class="btn">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
            `;
    }

    protected initPartial(): void {
        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.resultInfos = new resultsInfo_template("resultInfo", this.getTemplateViewModel(), this.caller);

        this.brandFilter = new multipleSelector_template("brandFilter", this.getTemplateViewModel(), this.caller);
        this.brandFilter.setLabel("Brands");
        this.brandFilter.setFilterContainerClass('margin-neg');
        this.brandFilter.setTagContainerId('selected-brands');
        this.brandFilter.setTagContainerCaption('Selected brands:');

        this.mailingListFilter = new multipleSelector_template("mailingListFilter", this.getTemplateViewModel(), this.caller);
        this.mailingListFilter.setLabel("Mailing Lists");
        this.mailingListFilter.setFilterContainerClass('margin-neg');
        this.mailingListFilter.setTagContainerId('selected-mailing-lists');
        this.mailingListFilter.setTagContainerCaption('Selected mailing lists:');
        this.mailingListFilter.setSelectAllEnabled(false);
        this.mailingListFilter.setSearchEnabled(true);

        this.filterPreset = new filterPreset_template("filterPreset", this.getTemplateViewModel(), this.caller);
        this.filterPreset.getTemplateViewModel().searchPresetType('websiteUserList');

        this.dateFilter = new filterDate_template("dateFilter", this.getTemplateViewModel(), this.caller);
        this.dateFilter.getTemplateViewModel().startDate(null);
        this.dateFilter.getTemplateViewModel().endDate(null);
        this.dateFilter.toggleClearButton(true);
        this.dateFilter.setLabel('Date Created');

        this.isActiveFilter = new multipleSelector_template("isActiveFilter", this.getTemplateViewModel(), this.caller);
        this.isActiveFilter.setLabel("Is Active")
        this.isActiveFilter.setFilterContainerClass('margin-neg');
        this.isActiveFilter.setTagContainerId('selected-is-active');
        this.isActiveFilter.setTagContainerCaption('Is active:');
        this.isActiveFilter.setItems([
            {id: 1, name: 'Yes'},
            {id: 0, name: 'No'}
        ]);

        this.isEmakiUserFilter = new multipleSelector_template("isEmakiUserFilter", this.getTemplateViewModel(), this.caller);
        this.isEmakiUserFilter.setLabel("Is Emaki User");
        this.isEmakiUserFilter.setFilterContainerClass('margin-neg');
        this.isEmakiUserFilter.setTagContainerId('selected-is-emaki-user');
        this.isEmakiUserFilter.setTagContainerCaption('Is emaki user:');
        this.isEmakiUserFilter.setItems([
            {id: 1, name: 'Yes'},
            {id: 0, name: 'No'}
        ]);

        this.isProfileVerifiedFilter = new multipleSelector_template("isProfileVerifiedFilter", this.getTemplateViewModel(), this.caller);
        this.isProfileVerifiedFilter.setLabel("Is Profile Verified");
        this.isProfileVerifiedFilter.setFilterContainerClass('margin-neg');
        this.isProfileVerifiedFilter.setTagContainerId('selected-is-profile-verified');
        this.isProfileVerifiedFilter.setTagContainerCaption('Is Profile Verified:');
        this.isProfileVerifiedFilter.setItems([
            {id: 1, name: 'Yes'},
            {id: 0, name: 'No'}
        ]);

        this.isPremiumFilter = new multipleSelector_template("isPremiumFilter", this.getTemplateViewModel(), this.caller);
        this.isPremiumFilter.setLabel("Is Premium");
        this.isPremiumFilter.setFilterContainerClass('margin-neg');
        this.isPremiumFilter.setTagContainerId('selected-is-premium');
        this.isPremiumFilter.setTagContainerCaption('Is Premium:');
        this.isPremiumFilter.setItems([
            {id: 1, name: 'Paid'},
            {id: 2, name: 'Free'},
            {id: 3, name: 'No'}
        ]);

        this.isRegisteredFilter = new multipleSelector_template("isRegisteredFilter", this.getTemplateViewModel(), this.caller);
        this.isRegisteredFilter.setLabel("Is Registered");
        this.isRegisteredFilter.setFilterContainerClass('margin-neg');
        this.isRegisteredFilter.setTagContainerId('selected-is-registered');
        this.isRegisteredFilter.setTagContainerCaption('Is registered:');
        this.isRegisteredFilter.setItems([
            {id: 1, name: 'Yes'},
            {id: 0, name: 'No'}
        ]);

        this.masterClassRegistrationFilter = new multipleSelector_template("masterClassRegistrationFilter", this.getTemplateViewModel(), this.caller);
        this.masterClassRegistrationFilter.setLabel("Master Class Registration");
        this.masterClassRegistrationFilter.setFilterContainerClass('margin-neg');
        this.masterClassRegistrationFilter.setTagContainerId('selected-master-class-registrations');
        this.masterClassRegistrationFilter.setTagContainerCaption('Master Class Registration:');

        this.userFilter = new filterWebsiteUser_template("userFilter", this.getTemplateViewModel(), this.caller);
        this.userFilter.asMultipleSelectionMode();
        this.userFilter.setTagContainerId('selected-users');
        this.userFilter.setTagContainerCaption('Selected users:');
        this.userFilter.setPlaceholderText("User");
        this.userFilter.setUniqueIdentifier("userId");

        this.accountDetailsTooltip = new  infoButton_template("accountDetailsButton", this.getTemplateViewModel(), this.caller);
        this.accountDetailsTooltip.setTitle("Account Details");
        this.accountDetailsTooltip.setContent(`
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-amazon"></i>Amazon Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-apple"></i>Apple Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-discord"></i>Discord Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-facebook"></i>Facebook Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-google"></i>Google Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-openPass"></i>OpenPass Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-twitch"></i>Twitch Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-steam"></i>Steam Sign-In </span>
                <span style="justify-content: flex-start;color: #fff;flex-direction: row;gap: 0.5rem;align-items: center;"><i class="icon i-user-v"></i>Verified email </span>
        `);



        this.displayNameStatusFilter = new multipleSelector_template("displayNameStatusFilter", this.getTemplateViewModel(), this.caller);
        this.displayNameStatusFilter.setLabel("Display Name Status");
        this.displayNameStatusFilter.setFilterContainerClass('margin-neg');
        this.displayNameStatusFilter.setTagContainerId('selected-display-name-status');
        this.displayNameStatusFilter.setTagContainerCaption('Display Name Status:');

        this.displayImageStatusFilter = new multipleSelector_template("displayImageStatusFilter", this.getTemplateViewModel(), this.caller);
        this.displayImageStatusFilter.setLabel("Display Image Status");
        this.displayImageStatusFilter.setFilterContainerClass('margin-neg');
        this.displayImageStatusFilter.setTagContainerId('selected-display-image-status');
        this.displayImageStatusFilter.setTagContainerCaption('Display Image Status:');

        this.coverImageStatusFilter = new multipleSelector_template("coverImageStatusFilter", this.getTemplateViewModel(), this.caller);
        this.coverImageStatusFilter.setLabel("Cover Image Status");
        this.coverImageStatusFilter.setFilterContainerClass('margin-neg');
        this.coverImageStatusFilter.setTagContainerId('selected-cover-image-status');
        this.coverImageStatusFilter.setTagContainerCaption('Cover Image Status:');

        this.hasInteractedFilter = new multipleSelector_template("hasInteractedFilter", this.getTemplateViewModel(), this.caller);
        this.hasInteractedFilter.setLabel("Has Interacted");
        this.hasInteractedFilter.setFilterContainerClass('margin-neg');
        this.hasInteractedFilter.setTagContainerId('selected-has-interacted');
        this.hasInteractedFilter.setTagContainerCaption('Has Interacted:');
        this.hasInteractedFilter.setItems([
            {id: 1, name: 'Followers'},
            {id: 2, name: 'Posts'},
            {id: 3, name: 'Ratings'},
            {id: 4, name: 'Reviews'},
            {id: 5, name: 'Threads'},
            {id: 6, name: 'Items in Lists'},
        ]);

        this.hasPersonalDataFilter = new multipleSelector_template("hasPersonalDataFilter", this.getTemplateViewModel(), this.caller);
        this.hasPersonalDataFilter.setLabel("Has Personal Data");
        this.hasPersonalDataFilter.setFilterContainerClass('margin-neg');
        this.hasPersonalDataFilter.setTagContainerId('selected-has-personal-data');
        this.hasPersonalDataFilter.setTagContainerCaption('Has Personal Data:');
        this.hasPersonalDataFilter.setItems([
            {id: 1, name: 'First Name'},
            {id: 2, name: 'Last Name'},
            {id: 3, name: 'Gender'},
            {id: 4, name: 'Age Group'},
            {id: 5, name: 'Country'},
            {id: 6, name: 'Postal/ZIP Code'},
            {id: 7, name: 'Profession'},
        ]);
    }

    protected getTemplateName(): string {
        return "websiteUsersList-template";
    }

    protected getMainElementType(): string {
        return "div";
    }

    protected getMainElementClasses(): Array<string> {
        return ["w-content"];
    }

    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return {
            onlyOneBrandSelected: ko.observable(false),
            orderBy: ko.observable("email")
            , orderByDirection: ko.observable("ASC")
            , websiteUsers: ko.observableArray([])
            , orderByAndDirection: ko.observable("email_ASC")
            , websiteUserToDelete: ko.observable(null)
            , threadSuggestions: ko.observableArray([])
            , threadSuggestionsToDelete: ko.observableArray([])
            , permissions: ko.observableArray(this.initPermissions(['newsletter_subscription_import_tool']))
            , accessibleBrandIds: ko.observable(null)
            ,paginationIsVisible: ko.observable(false)
            , isExporting: ko.observable(false)
            , exportProgressText: ko.observable('')
            , isExportModalVisible: ko.observable(false)
            , isExportCancelling: ko.observable(false)
            , onClickReorder: function (value, data, event) {
                huit_neuf_this.onClickReorder(value, data, event);
            }
            , onClickEdit: function (data, event) {
                const link = event.target.closest('a');
                if (link && link.href && link.href === data.profilePageLink) {
                    window.open(data.profilePageLink, '_blank');
                }
                else{
                    huit_neuf_this.onClickEdit(data.id);
                }
            }
            ,onClickShowDeletePopUp : (data, event) =>{
                huit_neuf_this.onClickShowDeletePopUp(data)
            }
            ,onClickHidePopUp : (id, data, event) =>{
                huit_neuf_this.onClickHidePopUp(id)
            }
            ,onClickDelete : (data, event) =>{
                huit_neuf_this.onClickDelete()
            }
            ,onClickDeleteConfirm : (data, event) =>{
                huit_neuf_this.onClickDeleteConfirm()
            }
            ,onClickImportWebsiteUsers : (data, event) =>{
                huit_neuf_this.onClickImportWebsiteUsers()
            },
            onClickExportCsv: (data, event) => {
                huit_neuf_this.onClickExportCsv();
            },
            onClickCancelExport: (data, event) => {
                huit_neuf_this.onClickCancelExport();
            },
            onChangeSelectBrand : (data, event) =>{
                huit_neuf_this.onChangeSelectBrand(data)
            }
        };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest() {
        let selectedItemsCount = this.getTemplateViewModel().brandFilter.selectedItems().length;
        this.getTemplateViewModel().onlyOneBrandSelected(selectedItemsCount == 1);

        return {
            orderBy: this.getTemplateViewModel().orderBy
            , orderByDirection: this.getTemplateViewModel().orderByDirection
            , orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            , pagination: this.getTemplateViewModel().pagination
            , searchPresetName: this.getTemplateViewModel().filterPreset.searchPresetName()
            , searchPresetType: this.getTemplateViewModel().filterPreset.searchPresetType()
            , getModerationData: true
            , filters: {
                keywords: this.getTemplateViewModel().filter.filterKeyword
                , brandIds : this.getTemplateViewModel().brandFilter.selectedItems
                , mailingListIds : this.getTemplateViewModel().mailingListFilter.selectedItems
                , isActive: this.getTemplateViewModel().isActiveFilter.selectedItems
                , isEmakiUser: this.getTemplateViewModel().isEmakiUserFilter.selectedItems
                , isRegistered: this.getTemplateViewModel().isRegisteredFilter.selectedItems
                , isPremium: this.getTemplateViewModel().isPremiumFilter.selectedItems
                , dateFilterType: this.getTemplateViewModel().dateFilter.selectedFilter()
                , startDate: this.getTemplateViewModel().dateFilter.startDate()
                , endDate: this.getTemplateViewModel().dateFilter.endDate()
                , startDateRange: this.getTemplateViewModel().dateFilter.fromRange()
                , endDateRange: this.getTemplateViewModel().dateFilter.toRange()
                , displayNameStatus: this.getTemplateViewModel().displayNameStatusFilter.selectedItems
                , displayImageStatus: this.getTemplateViewModel().displayImageStatusFilter.selectedItems
                , coverImageStatus: this.getTemplateViewModel().coverImageStatusFilter.selectedItems
                , hasInteracted: this.getTemplateViewModel().hasInteractedFilter.selectedItems
                , hasPersonalData: this.getTemplateViewModel().hasPersonalDataFilter.selectedItems
                , masterClassRegistrationIds: this.getTemplateViewModel().masterClassRegistrationFilter.selectedItems
                , accessPointUsers : this.userFilter.getUsersForRequest()
                , isProfileVerified: this.isProfileVerifiedFilter.getSelectedItems()
            },
        }
    }


    public onClickReorder(value, data, event) {

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)) {
            if (data.orderByDirection() == "DESC") {
                data.orderByDirection("ASC");
            } else {
                data.orderByDirection("DESC");
            }
        } else {
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.userListReorder();
    }


    public buildDatePickerCalendar(){

        this.dateFilter.buildCalendar();
    }

    public onClickEdit(id) {

        this.caller.editUserProfile(id);
    }

    public setUsers(websiteUsers: Array<WebsiteUser>): void {

        this.getTemplateViewModel().websiteUsers(websiteUsers);
    }

    public showActiveUsers() {
        this.caller.onShowActiveUsers();
        return true;
    }

    public setResultInfo(nbResults, nbPages, execTime, updateExecTime = true) {

        if(updateExecTime)  this.resultInfos.setExecutionTime(execTime);
        this.resultInfos.setNbResults(nbResults);
        this.resultInfos.setNbPages(nbPages);
    }

    public onClickShowDeletePopUp(data){

        if(!data){
            return;
        }

        this.caller.getWebsiteUserById(data);
    }

    public onClickHidePopUp(id){

        this.toggleDeleteDialogVisibility(id);

        if(id == 'website-user-delete-dialog'){
            this.resetWebsiteUserToDelete();
        }
    }

    public onClickDelete(){

        if(this.getTemplateViewModel().threadSuggestionsToDelete().length > 0){

            this.toggleDeleteDialogVisibility('thread-suggestions-delete-dialog');

        }else{

            this.onClickDeleteConfirm();
        }
    }

    public toggleDeleteDialogVisibility(id) {

        document.getElementById(id).classList.toggle('is-visible');
    }

    public reset() {

        this.resetWebsiteUserToDelete();
        document.getElementById('website-user-delete-dialog').classList.remove('is-visible');
        document.getElementById('thread-suggestions-delete-dialog').classList.remove('is-visible');
    }

    public onClickDeleteConfirm(){

        let websiteUserToDelete = this.getTemplateViewModel().websiteUserToDelete();
        this.caller.deleteWebsiteUser(websiteUserToDelete);
    }

    public resetWebsiteUserToDelete(){

        let websiteUserToDelete = this.getTemplateViewModel().websiteUserToDelete();

        if(!websiteUserToDelete){
            return;
        }

        websiteUserToDelete.accessPointUsers.forEach(data => {
            data.isDelete = false;
        })

        this.getTemplateViewModel().threadSuggestionsToDelete([]);
    }

    public setWebsiteUserToDelete(websiteUserToDelete){

        websiteUserToDelete.accessPointUsers.forEach(data => {
            data.isDelete = false;
        })

        this.getTemplateViewModel().websiteUserToDelete(websiteUserToDelete)
    }

    public setThreadSuggestions(threadSuggestions){

        this.getTemplateViewModel().threadSuggestions(threadSuggestions)
    }

    public setMailingLists(mailingLists){

        this.mailingListFilter.setItems(mailingLists);
    }

    public setBrands(brands){

        this.brandFilter.setItems(brands);
    }

    public setMasterClassRegistrations(masterClassRegistrations){

        this.masterClassRegistrationItems = (masterClassRegistrations || []).map((registration) => {
            let brandShortName = registration.brandShortName ? `(${registration.brandShortName}) - ` : '';

            return {
                id: parseInt(registration.id),
                idBrand: parseInt(registration.idBrand),
                name: brandShortName + registration.name
            };
        });

        this.updateMasterClassRegistrationFilterItems();
    }

    public updateMasterClassRegistrationFilterItems(){

        let brandSet = new Set(this.getTemplateViewModel().brandFilter.selectedItems().map((idBrand) => {
            return Number(typeof idBrand === 'object' ? idBrand.id : idBrand);
        }));

        let filteredItems = this.masterClassRegistrationItems.filter((registration) => {
            return brandSet.has(registration.idBrand);
        });

        let allowedIds = new Set(filteredItems.map((registration) => registration.id));
        let selectedRegistrationIds = this.masterClassRegistrationFilter.getSelectedItems()
            .map((idRegistration) => Number(idRegistration))
            .filter((id) => allowedIds.has(id));

        this.masterClassRegistrationFilter.setItems(filteredItems);
        this.masterClassRegistrationFilter.setSeletedItemIds(selectedRegistrationIds);
        this.masterClassRegistrationFilter.setTags(selectedRegistrationIds, filteredItems);
    }

    public setModerationStatusFilterOptions(moderationStatusFilterOptions){
        this.displayNameStatusFilter.setItems(moderationStatusFilterOptions);
        this.displayImageStatusFilter.setItems(moderationStatusFilterOptions);
        this.coverImageStatusFilter.setItems(moderationStatusFilterOptions);
    }

    public setSearchPresets(presets){

        this.filterPreset.setSearchPresets(presets);
    }

    public addCreatedPresetToList(response){

        this.filterPreset.addCreatedPresetToList(response);
    }

    public setViewModelFromRequest(urlParams){

        //check if URL has filters or user preferences
        if (urlParams != null){

            this.setFilterSelectedItems(this.brandFilter, urlParams.brandIds);
            this.setFilterSelectedItems(this.mailingListFilter, urlParams.mailingListIds);
            this.setFilterSelectedItems(this.isActiveFilter, urlParams.isActive);
            this.setFilterSelectedItems(this.isEmakiUserFilter, urlParams.isEmakiUser);
            this.setFilterSelectedItems(this.isPremiumFilter, urlParams.isPremium);
            this.setFilterSelectedItems(this.isRegisteredFilter, urlParams.isRegistered);
            this.setFilterSelectedItems(this.displayNameStatusFilter, urlParams.displayNameStatus);
            this.setFilterSelectedItems(this.displayImageStatusFilter, urlParams.displayImageStatus);
            this.setFilterSelectedItems(this.coverImageStatusFilter, urlParams.coverImageStatus);
            this.setFilterSelectedItems(this.hasInteractedFilter, urlParams.hasInteracted);
            this.setFilterSelectedItems(this.hasPersonalDataFilter, urlParams.hasPersonalData);
            this.setFilterSelectedItems(this.isProfileVerifiedFilter, urlParams.isProfileVerified);
            this.setFilterSelectedItems(this.masterClassRegistrationFilter, urlParams.masterClassRegistrationIds);
            this.updateMasterClassRegistrationFilterItems();
        }

        // date filters.
        if(urlParams.dateFilterType){
            this.dateFilter.getTemplateViewModel().selectedFilter(urlParams.dateFilterType);
        }
        if(urlParams.startDateRange || urlParams.endDateRange){

            this.dateFilter.setRange(urlParams.startDateRange, urlParams.endDateRange);
        }

        if(urlParams.startDate || urlParams.endDate) {
            this.setDateFilters(urlParams.startDate, urlParams.endDate);
        }

        // keyword filter.
        let keywordString = urlParams.keywords
        if(urlParams.keywords){
            keywordString = urlParams.keywords.replaceAll("+", " ");
        }

        if(urlParams.accessPointUsers && urlParams.accessPointUsers.length == 1){
            this.userFilter.setSelectedUsersFromRequestParams(urlParams.accessPointUsers);
        }

        this.filter.getTemplateViewModel().filterKeyword(keywordString);
    }

    private setDateFilters(startDate, endDate) {

        if(startDate){
            startDate = new Date(startDate.replace(/-/g, '\/'));
        }
        if(endDate){
            endDate = new Date(endDate.replace(/-/g, '\/'));
        }

        this.dateFilter.setDateRange(startDate, endDate);
    }

    public setFilterSelectedItems(objFilter, urlParams){

        let splitString = [];

        // Multi select filters.
        if(urlParams !== null && urlParams !== undefined) {
            if(typeof urlParams == "string"){
                splitString = urlParams.split(",");
            }else if(Array.isArray(urlParams)){
                splitString = urlParams;
            }else{
                splitString = [urlParams];
            }
            let arrayParam = [];
            let idTagArray = [];
            splitString.forEach((id) => {
                if(!isNaN(Number(id))){
                    id = Number(id);
                }else{
                    id = id.replaceAll("+", " ");
                }
                arrayParam.push({ id: id });
                idTagArray.push(id);
            });
            objFilter.setSelectedItems(arrayParam);
            objFilter.setTags(idTagArray, objFilter.getItems());
        }else{
            objFilter.setSelectedItems([]);
            objFilter.setTags([], objFilter.getItems());
        }
    }

    public onClickImportWebsiteUsers(){

        page(`/website-users/import`);
    }

    public onClickExportCsv(){

        this.caller.onClickExportCsv();
    }

    public onClickCancelExport(){
        this.caller.onClickCancelExport();
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }

    public setAccessibleBrandIds(brandIds){
        this.getTemplateViewModel().accessibleBrandIds(brandIds);
    }

    public onChangeSelectBrand(data){

        if(!data){
            return;
        }

        let threadSuggestionsToDelete = this.getTemplateViewModel().threadSuggestionsToDelete();
        let threadSuggestions = this.getTemplateViewModel().threadSuggestions();

        if(threadSuggestions.length > 0){

            if(data.isDelete){
                threadSuggestions.forEach(threadSuggestion => {
                    if(threadSuggestion.idAccessPoint == data.accessPoint.id){
                        threadSuggestionsToDelete.push(threadSuggestion);
                    }
                })
            }else{

                //remove from array if exists
                threadSuggestionsToDelete = threadSuggestionsToDelete.filter(threadSuggestion => {
                    if(threadSuggestion.idAccessPoint != data.accessPoint.id){
                        return threadSuggestion;
                    }
                })
            }
        }

        this.getTemplateViewModel().threadSuggestionsToDelete(threadSuggestionsToDelete);
    }

    public setPaginationIsVisible(isVisible){
        this.getTemplateViewModel().paginationIsVisible(isVisible);
    }

    public setExecutionTime(execTime){

        this.resultInfos.setExecutionTime(execTime);
    }

    public setExportState(isExporting: boolean, progressText: string = ''){
        this.getTemplateViewModel().isExporting(isExporting);
        this.getTemplateViewModel().exportProgressText(progressText);
    }

    public setExportModalVisible(isVisible: boolean){
        this.getTemplateViewModel().isExportModalVisible(isVisible);
    }

    public setExportCancelling(isCancelling: boolean){
        this.getTemplateViewModel().isExportCancelling(isCancelling);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/websiteUserList_template.ts